import React from 'react';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import ContestIndexPageContainer from 'buyside/components/container/ContestIndex/ContestIndexPageContainer';

const ContestIndexPageRoot = () => {
  return (
    <ErrorBoundary pageName="Contest Index">
      <ContestIndexPageContainer />
    </ErrorBoundary>
  );
};

export default ContestIndexPageRoot;
